'use strict';
import {TaskType} from '../enums/TaskType';
import {assetTaskListActions} from './assetListActions';
import {projectTaskListActions} from './projectListActions';
import {templateTaskListActions} from './templateListActions';


export * from './assetListActions';
export * from './projectListActions';
export * from './templateListActions';

/**
 * @return {ReduxObservableListActions}
 */
export function getTaskListActions(taskType) {
  switch (taskType) {
    case TaskType.ASSET:
      return assetTaskListActions;
    case TaskType.PROJECT:
      return projectTaskListActions;
    case TaskType.TEMPLATE:
      return templateTaskListActions;
  }
}



// WEBPACK FOOTER //
// ./src/js/tasks/actions/index.js